var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    fill: "white",
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.718 3.049a9.061 9.061 0 0 0 -7.524-1.873 9 9 0 0 0 -3.671 15.957 15.25 15.25 0 0 1 3.921 4.217l.7 1.164a1 1 0 0 0 1.714 0l.671-1.118a12.72 12.72 0 0 1 3.578-4 8.99 8.99 0 0 0 .612-14.352zm-5.718 10.951a4 4 0 1 1 4-4 4 4 0 0 1 -4 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4ff24933f97ef0066d1019a7e7e85f20.svg";
export { ForwardRef as ReactComponent };